import React, { useEffect } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "../Footer";

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-17386879354/s5AKCM2phIwbEPry2uJA",
      });
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_submission",
      page: "thankyou",
    });
  }, []);

  return (
    <Box>
      <Helmet>
        <title>Thank You | GroHair & GloSkin Dindigul</title>
      </Helmet>

      <Container
        maxWidth="sm"
        sx={{
          pt: { xs: 18, md: 16 },
          pb: { xs: 10, md: 12 },
          textAlign: "center",
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 72, color: "#2e7d32", mb: 2 }} />
        <Typography variant="h3" fontWeight="bold" sx={{ color: "#2e7d32", mb: 2 }}>
          Thank You!
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
          Your submission has been received. Our team will get in touch with you shortly.
        </Typography>
        <Button
          variant="contained"
          size="large"
          sx={{
            bgcolor: "#e3242b",
            textTransform: "none",
            fontWeight: "bold",
            px: 4,
            "&:hover": { bgcolor: "#c81d15" },
          }}
          onClick={() => navigate("/")}
        >
          Back to Home
        </Button>
      </Container>

      <Footer />
    </Box>
  );
};

export default ThankYou;
